module.exports = __webpack_public_path__ + "static/report-d6a344621f72b4996d5820970c199ad0.mp4";